<template>
  <div>
    <input type="checkbox" />
  </div>
</template>

<script>
export default {};
</script>

<style></style>
